import { z } from 'zod';
export const PO_COPY_MANIFEST_LIMIT = 10000;
export const PO_COPY_BATCH_LIMIT = 100;
export const PO_COPY_EXPORT_BYTES = 8 * 1024 * 1024;
export const poDocumentManifestInput = z
  .object({ from: z.string().date().optional(), to: z.string().date().optional() })
  .strict()
  .refine((v) => !v.from || !v.to || v.from <= v.to, {
    message: 'Choose an end date on or after the start date',
  });
export type PoDocumentManifestInput = z.infer<typeof poDocumentManifestInput>;
export const poDocumentBatchInput = z
  .object({
    documentIds: z
      .array(z.string().uuid())
      .min(1)
      .max(PO_COPY_BATCH_LIMIT)
      .refine(
        (ids) => new Set(ids).size === ids.length,
        'Choose each supplier copy once',
      ),
  })
  .strict();
export type PoDocumentBatchInput = z.infer<typeof poDocumentBatchInput>;
export interface PoCopyManifestEntry {
  documentId: string;
  purchaseOrderId: string;
  filename: string;
  byteSize: number;
  sha256: string;
  createdAt: string;
}
export interface PoCopyManifest {
  capturedAt: string;
  count: number;
  cohortHash: string;
  documents: PoCopyManifestEntry[];
}
export interface PoCopyPage {
  file: { filename: string; csv: string; rowCount: number };
  documentIds: string[];
  remainingDocumentIds: string[];
}
